import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"chevron-down\"><path fill=\"currentColor\" d=\"M26.297 12.625L14.703 24.203a.99.99 0 01-1.406 0L1.703 12.625a1.009 1.009 0 010-1.422l2.594-2.578a.99.99 0 011.406 0L14 16.922l8.297-8.297a.99.99 0 011.406 0l2.594 2.578a1.009 1.009 0 010 1.422z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol